import React from 'react';
import { motion } from 'framer-motion';
import { ArrowDown } from 'lucide-react';
export function MechanismSection() {
  const steps = [{
    num: 1,
    title: 'Demand hits too soon',
    desc: 'questions, errands, homework, “use your words”'
  }, {
    num: 2,
    title: 'Body needs aren’t met',
    desc: 'hunger, thirst, decompression, movement'
  }, {
    num: 3,
    title: 'Mom gets pulled into escalation',
    desc: 'negotiating, explaining, repeating'
  }, {
    num: 4,
    title: 'Kid’s brain goes offline',
    desc: 'behavior gets louder'
  }, {
    num: 5,
    title: 'Everyone feels awful',
    desc: 'guilt + exhaustion → same tomorrow'
  }];
  return <section className="py-24 px-4 md:px-6 bg-sage-dark text-cream-100 relative overflow-hidden" data-id="element-119">
      {/* Background decoration */}
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden opacity-10 pointer-events-none" data-id="element-120">
        <svg viewBox="0 0 100 100" preserveAspectRatio="none" className="w-full h-full" data-id="element-121">
          <path d="M0 0 C 50 100 80 100 100 0 Z" fill="currentColor" data-id="element-122" />
        </svg>
      </div>

      <div className="max-w-4xl mx-auto relative z-10" data-id="element-123">
        <div className="text-center mb-16" data-id="element-124">
          <span className="uppercase tracking-widest text-sage-light text-sm font-bold mb-3 block" data-id="element-125">
            Mechanism Reveal
          </span>
          <h2 className="text-3xl md:text-5xl font-bold text-cream-50 mb-6" data-id="element-126">
            The 4PM Overload Loop™
          </h2>
          <p className="text-xl text-sage-light/80" data-id="element-127">
            The meltdown cycle usually looks like this:
          </p>
        </div>

        <div className="relative" data-id="element-128">
          {/* Connecting Line */}
          <div className="absolute left-8 md:left-1/2 top-4 bottom-4 w-1 bg-sage-light/20 -translate-x-1/2 hidden md:block" data-id="element-129" />

          <div className="space-y-8 md:space-y-12" data-id="element-130">
            {steps.map((step, index) => <motion.div key={index} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true,
            margin: '-50px'
          }} transition={{
            delay: index * 0.1
          }} className={`flex flex-col md:flex-row gap-6 md:gap-12 items-center ${index % 2 === 0 ? 'md:flex-row-reverse' : ''}`} data-id="element-131">
                {/* Content Side */}
                <div className={`flex-1 ${index % 2 === 0 ? 'md:text-left' : 'md:text-right'} text-center md:text-left w-full`} data-id="element-132">
                  <h3 className="text-xl md:text-2xl font-bold text-cream-50 mb-2" data-id="element-133">
                    {step.title}
                  </h3>
                  <p className="text-sage-light/70 text-lg" data-id="element-134">{step.desc}</p>
                </div>

                {/* Number Circle */}
                <div className="relative flex-shrink-0 z-10" data-id="element-135">
                  <div className="w-16 h-16 rounded-full bg-terracotta flex items-center justify-center text-2xl font-bold text-white shadow-lg shadow-black/20 border-4 border-sage-dark" data-id="element-136">
                    {step.num}
                  </div>
                  {index < steps.length - 1 && <div className="absolute -bottom-10 left-1/2 -translate-x-1/2 text-sage-light/30 md:hidden" data-id="element-137">
                      <ArrowDown data-id="element-138" />
                    </div>}
                </div>

                {/* Empty Side for Balance */}
                <div className="flex-1 hidden md:block" data-id="element-139" />
              </motion.div>)}
          </div>
        </div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.9
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} className="mt-20 text-center bg-white/10 backdrop-blur-sm p-8 md:p-10 rounded-3xl border border-white/10" data-id="element-140">
          <p className="text-xl md:text-2xl font-serif text-cream-50 leading-relaxed" data-id="element-141">
            So the solution isn’t “better discipline.”{' '}
            <br className="hidden md:block" data-id="element-142" />
            It’s{' '}
            <span className="text-terracotta font-bold" data-id="element-143">
              interrupting the loop
            </span>{' '}
            before it locks in.
          </p>
          <p className="mt-4 text-lg text-sage-light" data-id="element-144">
            That’s what the 30-Minute Reset is for.
          </p>
        </motion.div>
      </div>
    </section>;
}